import apiClient from "../client.js";
import { API_URLS } from "../urls.js";

export const login = (credentials) =>
  apiClient.post(API_URLS.AUTH.LOGIN, credentials);

export const adminLogin = (credentials) =>
  apiClient.post(API_URLS.AUTH.ADMIN_LOGIN, credentials);

export const register = (data) => apiClient.post(API_URLS.AUTH.REGISTER, data);

export const getDashboardSummary = () => apiClient.get(API_URLS.DASHBOARD.SUMMARY);